<template>
  <div class="zj-emergency-person-schedule">
    <div class="zj-emergency-person-search-box">
      <input
        class="zj-emergency-person-search-box-input"
        v-model="searchText"
        type="text"
        placeholder="请输入姓名"
      />
      <div class="zj-emergency-person-search-box-btn" v-on:click="searchconcat"></div> 
    </div>
    <el-tabs class="person-tabs custom-tabs" v-model="activeTab">
      <el-tab-pane
        :key="item.code"
        v-for="(item) in personOrgianiztionType"
        :label="item.value"
        :name="item.code"
      >
        <UserOrgControl :roomId="roomId" :pwd="pwd"  v-bind:ExecutId="ExecutId" :PersonName="searchText" :ResourceTypeId="item.code" :ref="item.code"></UserOrgControl>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import UserOrgControl from "./Component-UserOrgControl";
import { getDictionary } from "@/api/src/emergency_common";
export default {
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    roomId: {
      type: String
    },
    pwd: {
      type: String
    }
  },
  components: {
    UserOrgControl
  },
  data() {
    return {
      ruleForm: {},
      personOrgianiztionType: [], // 人员类型
      activeTab: "",
      searchText:""
    };
  },
  created: function() {
    let that = this;
    getDictionary('organization_type')
      .then(d => {
        if (d.data.records && d.data.records.length > 0) {
          that.personOrgianiztionType = d.data.records;
          that.activeTab = d.data.records[0].code;

          //that.loadOrg(that.activeTab);
        }
      })
      .catch(e => {
        console.error(e);
      });
  },
  methods:{
    searchconcat:function(){

    }
  }
};
</script>